import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MapService } from '../../../services/map.service';
import { RoutingService } from '../../../services/routing.service';

@Component({
  selector: 'measure-tool',
  templateUrl: './measure-tool.component.html',
  styleUrl: './measure-tool.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class MeasureToolComponent {
  private _mapService = inject(MapService);
  private _routingService = inject(RoutingService);
  public $isMeasuring = this._mapService.$measureMapDistance;
  public $isMobile = this._routingService.$isMobile;
  public $distance = this._mapService.$distanceValue;
}
